import {
    ICampaignType,
    ICampaignStatus,
    ICampaignFieldsFragment,
} from '@copilot/data/graphql/_generated';
import { CampaignStatusEnum } from '@copilot/data/requests/models';
import { CampaignResponse, CampaignType } from '@copilot/data/responses/interface';
import { isNil } from 'lodash';
import { OrganizationMember } from '@copilot/common/store/models/redux/organizationMember';
import { Ref, SessionBoundModel } from 'redux-orm';

export function convertCampaignToReduxData(
    campaign?: ICampaignFieldsFragment,
    orgMember?: SessionBoundModel<OrganizationMember> | Ref<OrganizationMember> | null
): CampaignResponse {
    if (isNil(campaign) || isNil(orgMember)) {
        throw new Error('Campaign is required');
    }
    return {
        id: campaign.id,
        name: campaign.name ?? '<Unknown Campaign>',
        type:
            campaign.type === ICampaignType.Prospecting
                ? CampaignType.Prospecting
                : CampaignType.Nurture,
        organizationId: orgMember.organizationId,
        status:
            campaign.status === ICampaignStatus.Enabled
                ? CampaignStatusEnum.Enabled
                : CampaignStatusEnum.Disabled,
        members: campaign.members.map((member) => ({
            id: member.id,
            orgMemberId: member.orgMemberId,
            firstName: orgMember.firstName,
            lastName: orgMember.lastName,
            email: orgMember.email,
            phoneNumber: orgMember.phoneNumber,
            dailyInvitesAllocated: member.dailyInvitesAllocated,
            dailyMessagesAllocated: member.dailyMessagesAllocated,
            status: 1,
        })),
    };
}
